import React, { useState } from 'react'
import kidsbedroomwithmodular1 from '../../assets/designgallery/kids/KidsBedroomWithModularFurniture/kidsbedroomwithmodular furniture (1).jpg'
import kidsbedroomwithmodular2 from '../../assets/designgallery/kids/KidsBedroomWithModularFurniture/kidsbedroomwithmodular furniture (2).jpg'
import kidsbedroomwithmodular3 from '../../assets/designgallery/kids/KidsBedroomWithModularFurniture/kidsbedroomwithmodular furniture (3).jpg'
import kidsbedroomwithmodular4 from '../../assets/designgallery/kids/KidsBedroomWithModularFurniture/kidsbedroomwithmodular furniture (4).jpg'
import kidsbedroomwithmodular5 from '../../assets/designgallery/kids/KidsBedroomWithModularFurniture/kidsbedroomwithmodular furniture (5).jpg'
import kidsbedroomwithmodular6 from '../../assets/designgallery/kids/KidsBedroomWithModularFurniture/kidsbedroomwithmodular furniture (6).jpg'

import kidsbedroomwithstorage1 from '../../assets/designgallery/kids/ModernKidsBedroomWithStorage/kidsbedroomwithstorage (5).avif'
import kidsbedroomwithstorage2 from '../../assets/designgallery/kids/ModernKidsBedroomWithStorage/kidsbedroomwithstorage (2).avif'
import kidsbedroomwithstorage3 from '../../assets/designgallery/kids/ModernKidsBedroomWithStorage/kidsbedroomwithstorage (3).avif'
import kidsbedroomwithstorage4 from '../../assets/designgallery/kids/ModernKidsBedroomWithStorage/kidsbedroomwithstorage (6).avif'
import kidsbedroomwithstorage5 from '../../assets/designgallery/kids/ModernKidsBedroomWithStorage/kidsbedroomwithstorage (1).jpg'
import kidsbedroomwithstorage6 from '../../assets/designgallery/kids/ModernKidsBedroomWithStorage/kidsbedroomwithstorage (4).avif'

import kidsbedroomforboyandgirl from '../../assets/designgallery/kids/KidsBedroomForBoyAndGirl/kidsbedroomforboyandgirl (1).avif'
import kidsbedroomforboyandgir2 from '../../assets/designgallery/kids/KidsBedroomForBoyAndGirl/kidsbedroomforboyandgirl (1).webp'
import kidsbedroomforboyandgir3 from '../../assets/designgallery/kids/KidsBedroomForBoyAndGirl/kidsbedroomforboyandgirl (1).jpg'
import kidsbedroomforboyandgir4 from '../../assets/designgallery/kids/KidsBedroomForBoyAndGirl/kidsbedroomforboyandgirl (5).jpg'
import kidsbedroomforboyandgir5 from '../../assets/designgallery/kids/KidsBedroomForBoyAndGirl/kidsbedroomforboyandgirl (6).jpg'
import kidsbedroomforboyandgir6 from '../../assets/designgallery/kids/KidsBedroomForBoyAndGirl/kidsbedroomforboyandgirl (7).jpg'

import kidsbedroomforsmallhomes1 from '../../assets/designgallery/kids/KidsBedroomForSmallHomes/kidsbedroomforsmallhomes (1).jpg'
import kidsbedroomforsmallhomes2 from '../../assets/designgallery/kids/KidsBedroomForSmallHomes/kidsbedroomforsmallhomes (10).jpg'
import kidsbedroomforsmallhomes3 from '../../assets/designgallery/kids/KidsBedroomForSmallHomes/kidsbedroomforsmallhomes (1).avif'
import kidsbedroomforsmallhomes4 from '../../assets/designgallery/kids/KidsBedroomForSmallHomes/kidsbedroomforsmallhomes (16).jpg'
import kidsbedroomforsmallhomes5 from '../../assets/designgallery/kids/KidsBedroomForSmallHomes/kidsbedroomforsmallhomes (17).jpg'
import kidsbedroomforsmallhomes6 from '../../assets/designgallery/kids/KidsBedroomForSmallHomes/kidsbedroomforsmallhomes (18).jpg'

import kidsbedroomwithstudyunit1 from '../../assets/designgallery/kids/KidsBedroomWithStudy Unit/kidsbedroomwithstudyunit (1).jpg'
import kidsbedroomwithstudyunit2 from '../../assets/designgallery/kids/KidsBedroomWithStudy Unit/kidsbedroomwithstudyunit (2).jpg'
import kidsbedroomwithstudyunit3 from '../../assets/designgallery/kids/KidsBedroomWithStudy Unit/kidsbedroomwithstudyunit (3).jpg'
import kidsbedroomwithstudyunit4 from '../../assets/designgallery/kids/KidsBedroomWithStudy Unit/kidsbedroomwithstudyunit (4).jpg'
import kidsbedroomwithstudyunit5 from '../../assets/designgallery/kids/KidsBedroomWithStudy Unit/kidsbedroomwithstudyunit (5).jpg'
import kidsbedroomwithstudyunit6 from '../../assets/designgallery/kids/KidsBedroomWithStudy Unit/kidsbedroomwithstudyunit (6).jpg'

import { Link } from 'react-router-dom'
import { BiSolidOffer } from 'react-icons/bi'
import { MdOutlineReplay10, MdOutlineThumbUpAlt } from 'react-icons/md'


const KidsBedroom = () => {
  // **************************************************
 const [isExpanded1, setIsExpanded1] = useState(true);
 
 const toggleContent1 = () => {
 setIsExpanded1(prev => !prev);
 };
 // *****************************************
 // *****************************************
 const [isExpanded2, setIsExpanded2] = useState(false);
 
 const toggleContent2 = () => {
 setIsExpanded2(prev => !prev);
 };
 // ************************************************

  return (
    <div className='kids design-gallery'>
        <div className='kids-heading container'>
            <h3>Kids Bedroom Designs</h3>
                <p className='para'>
                    Check out the popular kids bedroom interior designs amongst our happy customers.
                </p>       
        </div>
        {/* ********************************************* */}
        <div className='shapes container'>
          {/* slider 1 */}
          <div id="carouselExampleIndicators" class="carousel slide">
                          <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
                          </div>
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={kidsbedroomwithmodular1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithmodular2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithmodular3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithmodular4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithmodular5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithmodular6} class="d-block w-100" alt="..."/>
                          </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
          </div>

           <div className='images-details mt-3'>
              <p className='img-details-and-btn'>A Kids Bedroom Design With Modular Furniture <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>

              {/* Show More button */}
              {!isExpanded1 && (
                <button
                  className=" show-more btn mt-2"
                  onClick={toggleContent1}
                  aria-expanded={isExpanded1}
                >
                  Show More ▼
                </button>
              )}

              {/* Expanded content */}
              {isExpanded1 && (
                <div className="extra-info mt-3 ">
                  <p className='extra-info-para'>
                    This kids bedroom has been designed with a grey coloured wardrobe that has an attached study unit.
                    A bed with yellow drawers underneath provide storage for toys and other items.
                  </p>
                  <p className='extra-info-features'>Special Features</p>
                  <ul className='extra-info-list'>
                    <li>A wardrobe with an attached study unit in grey.</li>
                    <li>Open shelves in white to display toys.</li>
                    <li>Wooden flooring brings in warmth to the space.</li>
                    <li>An accent wall in grey and yellow adds an element of fun to this kids bedroom.</li>
                    <li>A single bed with drawers for storage.</li>
                  </ul>

                  {/* Show Less button */}
                  <button
                    className=" show-less btn  mt-3"
                    onClick={toggleContent1}
                    aria-expanded={isExpanded1}
                  >
                    Show Less ▲
                  </button>
                </div>
              )}
          </div>
          {/* slider 1 end */}
          <div style={{margin:'80px'}}  ></div>


          {/* slider 2 */}
          <div id="carouselExampleIndicators1" class="carousel slide">
                          <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="5" aria-label="Slide 6"></button>
                          </div>
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={kidsbedroomwithstorage1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstorage2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstorage3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstorage4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstorage5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstorage6} class="d-block w-100" alt="..."/>
                          </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
          </div>
           <div className='images-details mt-3'>
                          <p className='img-details-and-btn'>A Modern Kids Bedroom With Storage <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
          
                          {/* Show More button */}
                          {!isExpanded2 && (
                            <button
                              className=" show-more btn  mt-2"
                              onClick={toggleContent2}
                              aria-expanded={isExpanded2}
                            >
                              Show More ▼
                            </button>
                          )}
          
                          {/* Expanded content */}
                          {isExpanded2 && (
                            <div className="extra-info mt-3 ">
                              <p className='extra-info-para'>
                                  This modern kids bedroom has a storage bed with a lot of open shelf storage as well.
                                  An extended study unit has been designed with a combination of open box and floating shelves to keep everything organised.
                              </p>
                              <p className='extra-info-features'>Special Features</p>
                              <ul className='extra-info-list'>
                                <li>A storage bed with drawers.</li>
                                <li>An extended study unit.</li>
                                <li>Open shelves and floating shelves for storage.</li>
                              </ul>
          
                              {/* Show Less button */}
                              <button
                                className=" show-less btn  mt-3"
                                onClick={toggleContent2}
                                aria-expanded={isExpanded2}
                              >
                                Show Less ▲
                              </button>
                            </div>
                          )}
            </div>

          {/* slider 2 end  */}
          <div style={{margin:'80px'}}  ></div>

          {/* slider 3 */}

          <div id="carouselExampleIndicators2" class="carousel slide">
                          <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="5" aria-label="Slide 6"></button>
                          </div>
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={kidsbedroomforboyandgirl} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforboyandgir2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforboyandgir3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforboyandgir4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforboyandgir5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforboyandgir6} class="d-block w-100" alt="..."/>
                          </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
          </div>
          <div className='images-details mt-3'>
                          <p className='img-details-and-btn'>A Kids Bedroom Design For A Boy And A Girl <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
          
                          {/* Show More button */}
                          {!isExpanded2 && (
                            <button
                              className=" show-more btn  mt-2"
                              onClick={toggleContent2}
                              aria-expanded={isExpanded2}
                            >
                              Show More ▼
                            </button>
                          )}
          
                          {/* Expanded content */}
                          {isExpanded2 && (
                            <div className="extra-info mt-3 ">
                              <p className='extra-info-para'>
                                A fresh lime green and pink themed kids bedroom with LED strip lighting. 
                                This kids bedroom is perfect for growing kids as you won’t need to change the decor right through their teenage years.
                                This one’s perfect for kids who like and edgy look with a fun factor thrown in.
                              </p>
                              <p className='extra-info-features'>Special Features</p>
                              <ul className='extra-info-list'>
                                <li>Two single cots one for her and another for him.</li>
                                <li>A wardrobe with push to open doors and shelves inside.</li>
                                <li>Twin study units in green and pink with matching set drawers and chairs.</li>
                              </ul>
          
                              {/* Show Less button */}
                              <button
                                className=" show-less btn  mt-3"
                                onClick={toggleContent2}
                                aria-expanded={isExpanded2}
                              >
                                Show Less ▲
                              </button>
                            </div>
                          )}
          </div>
          {/* slider 3 end */}
          
          <div style={{margin:'80px'}}  ></div>


        </div>
        {/* ********************************************* */}
        {/*whychooseourkitchen*/}
                    <div className='whyourkitchen'>
                      <h3>Why Choose Our Kids Bedroom Designs</h3>
                      <div className='whyourkitchen-reason'>
                        <div className='icon-para-div1'>
                          <BiSolidOffer className='icon'/>
                          <p className='whyourkitchen-para'>20% Extra Space</p>
                        </div>
                        <div className='icon-para-div1'>
                          <MdOutlineReplay10  className='icon'/>
                          <p className='whyourkitchen-para'>10 Year Warranty</p>
                        </div>
                        <div className='icon-para-div1'>
                          <MdOutlineThumbUpAlt   className='icon'/>
                          <p className='whyourkitchen-para'>Installation by Professionals</p>
                        </div>
                      </div>
                    </div>
        {/*whychooseourkitchen*/}
        {/* ************************************************* */}
        <div className='shapes container'>
          {/* slider 4 */}
           <div id="carouselExampleIndicators3" class="carousel slide">
                          <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="5" aria-label="Slide 6"></button>
                          </div>
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={kidsbedroomforsmallhomes1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforsmallhomes2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforsmallhomes3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforsmallhomes4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforsmallhomes5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomforsmallhomes6} class="d-block w-100" alt="..."/>
                          </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
           
           
           
           </div>

          <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>A Kids Bedroom Design For A Boy And A Girl <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
            
                            {/* Show More button */}
                            {!isExpanded2 && (
                              <button
                                className=" show-more btn  mt-2"
                                onClick={toggleContent2}
                                aria-expanded={isExpanded2}
                              >
                                Show More ▼
                              </button>
                            )}
            
                            {/* Expanded content */}
                            {isExpanded2 && (
                              <div className="extra-info mt-3 ">
                                <p className='extra-info-para'>
                                  A fresh lime green and pink themed kids bedroom with LED strip lighting. 
                                  This kids bedroom is perfect for growing kids as you won’t need to change the decor right through their teenage years.
                                  This one’s perfect for kids who like and edgy look with a fun factor thrown in.
                                </p>
                                <p className='extra-info-features'>Special Features</p>
                                <ul className='extra-info-list'>
                                  <li>Two single cots one for her and another for him.</li>
                                  <li>A wardrobe with push to open doors and shelves inside.</li>
                                  <li>Twin study units in green and pink with matching set drawers and chairs.</li>
                                </ul>
            
                                {/* Show Less button */}
                                <button
                                  className=" show-less btn  mt-3"
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                  Show Less ▲
                                </button>
                              </div>
                            )}
          </div>
          {/* slider 4 end */}
          <div style={{margin:'80px'}}  ></div>

          {/* slider 5 */}

           <div id="carouselExampleIndicators4" class="carousel slide">
                          <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="5" aria-label="Slide 6"></button>
                          </div>
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={kidsbedroomwithstudyunit1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstudyunit2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstudyunit3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstudyunit4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstudyunit5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={kidsbedroomwithstudyunit6} class="d-block w-100" alt="..."/>
                          </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
           
           
           
           </div>

           <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>A Kids Bedroom With Bookshelf and Study Unit <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
            
                            {/* Show More button */}
                            {!isExpanded2 && (
                              <button
                                className=" show-more btn  mt-2"
                                onClick={toggleContent2}
                                aria-expanded={isExpanded2}
                              >
                                Show More ▼
                              </button>
                            )}
            
                            {/* Expanded content */}
                            {isExpanded2 && (
                              <div className="extra-info mt-3 ">
                                <p className='extra-info-para'>
                                  This kids bedroom features an MDC cutting duco panel that replicates buildings and apartments. 
                                  An attached study with window bay seating and bookshelf makes this room a haven for kids.
                                </p>
                                <p className='extra-info-features'>Special Features</p>
                                <ul className='extra-info-list'>
                                 
                                  <li>A kids bedroom in grey and white colour scheme.</li>
                                  <li>A double bed with twin side tables with industrial fitting lamp lighting.</li>
                                  <li>An open box bookshelf that extends into handleless drawer cabinets.</li>
                                  <li>A window bay seating with storage underneath.</li>
                                  <li>The seating extends into a floor-to-ceiling study unit with backlit box shelves, table, desk and storage.</li>
                                </ul>
            
                                {/* Show Less button */}
                                <button
                                  className=" show-less btn  mt-3"
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                  Show Less ▲
                                </button>
                              </div>
                            )}
          </div>

          {/* slider 5 end*/}
          <div style={{margin:'80px'}}  ></div>

          





        </div>
         {/* ********************************************* */}
        {/*whychooseourkitchen*/}
                    <div className='whyourkitchen'>
                      <h3>Why Choose Our Kids Bedroom Designs</h3>
                      <div className='whyourkitchen-reason'>
                        <div className='icon-para-div1'>
                          <BiSolidOffer className='icon'/>
                          <p className='whyourkitchen-para'>20% Extra Space</p>
                        </div>
                        <div className='icon-para-div1'>
                          <MdOutlineReplay10  className='icon'/>
                          <p className='whyourkitchen-para'>10 Year Warranty</p>
                        </div>
                        <div className='icon-para-div1'>
                          <MdOutlineThumbUpAlt   className='icon'/>
                          <p className='whyourkitchen-para'>Installation by Professionals</p>
                        </div>
                      </div>
                    </div>
        {/*whychooseourkitchen*/}
        {/* ************************************************* */}

        {/* faq's onkids bedroom designs */}
        <div className=' design gallery faq '>
        <h2 className=' design faq-heading'>Frequently asked questions on Home Office Designs</h2>
        {/* <Link to="/contactForm" classNameName="btn btn-warning">Enquiry Form</Link> */}
        <div className="accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                1. Are bunk beds good for kids
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Bunk beds are great space savers and children enjoy them too. Bunk beds are fun for children, but you need to be careful as they can injure themselves if they are not careful
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                2. What is the best color for a teenage girl's bedroom?
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" >
              <div className="accordion-body">
                The colour options for teenage girl’s bedroom are plenty. You can go for any pastel shade or something brighter – try shades of pink, purple, yellow or green. Blue is a great option tooThe colour options for teenage girl’s bedroom are plenty. You can go for any pastel shade or something brighter
                – try shades of pink, purple, yellow or green. Blue is a great option too
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                3.How can a teenage girl decorate a small bedroom?
              </button>
            </h2>
            <div id="flush-collapseThree" className="accordion-collapse collapse" >
              <div className="accordion-body">
                A teenage girls bedroom can be decorated with wall accents, rugs, colourful pillows and pretty decorative like lamps or ceramic figurines.
                You can also add wall shelves and display them with books or indoor planters.
             
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                4.How do you make a kids room fun?
              </button>
            </h2>
            <div id="flush-collapseFour" className="accordion-collapse collapse" >
              <div className="accordion-body">
                 Kids room can be made fun with multifunctional furniture like foldable study tables, bunkbeds, play dens and colourful storage cabinets. You can also spruce it up with decor like rugs, carpets, 
                 cushions, curtains and stuffed toys.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                5. How do you arrange furniture in a chilld's bedroom ?
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" >
              <div className="accordion-body">
                The arrangement of furniture depends on the number of pieces and available space. Just make sure you place furniture away from the door so they can open and close it easily.

              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                6. How do I make my toddler's room cozy?
              </button>
            </h2>
            <div id="flush-collapseSix" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Children need a space to relax and fall asleep easily. First thing you need to do to make a toddler’s room cozy is install dimmers so you can regulate the brightness. 
                A reading light is also a good idea if you want to visit this room in the middle of the night. Make sure the bed has a comfortable mattress woth lots of soft pillows.
                Also, make sure the noise levels are low so they can get a restful sleep.
                  
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
                7.How can i save space in my kids room?
              </button>
            </h2>
            <div id="flush-collapseSeven" className="accordion-collapse collapse" >
              <div className="accordion-body">
                 There are many design hacks you can use to save space in your toddlers bedroom. Go vertical with bedding and storage. Keep some toys out of reach. Use space saving furniture like pull-out desks,
                 beds with drawers, organise clothes and shoes in storage bins.
                 
              </div>
            </div>
          </div>
        
        </div>
       </div>

        <p className='disclaimer container'>Kindly note: Product images are representative and may not reflect exact offerings. Please contact us to create a design customized for you.</p>








    </div>
  )
}

export default KidsBedroom